import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { Form, Row, Col, Button, Card } from 'antd'
import { Formik } from 'formik'

import CustomSelect from '../../../../components/CustomSelect/customSelect'
import SelectOrganization from '../../../../components/SelectOrganization/SelectOrganization'
import { getMessage } from '../../../../util/IntlMessages'
import { api, request } from '../../../../util/handlerRequestUtil'
import { isAdmin, isGR } from '../../../../util/profiles'

import './styles.css'

export const EibFilter = ({ filter, setFilter }) => {
  const [internalFilter, setInternalfilter] = useState({})

  const [data, setData] = useState({
    safra: [],
    marca: [],
    regional: [],
    distrito: [],
    categoria: [],
    tipo_de_acao: []
  })

  const currentUser = useSelector((state) => state.auth.auth)

  useEffect(() => {
    if (data.safra.length === 0) {
      setup()
    }
  }, [])

  async function handleClickFilter() {
    setFilter({ ...internalFilter })
  }

  async function handleClickClearFilter() {
    setInternalfilter({})
    setFilter({})
    setup()
  }

  // Fetch Data
  async function setup() {
    const safras = await request(api.listSafraDropdown({ active: true, todos: false }))
    const categories = await fetchCategories()
    const regions = await fetchRegions()
    let filterValues
    let dataValues = { safra: safras, categoria: categories }

    if (isAdmin(currentUser)) {
      filterValues = { marca_id: '-1', regional_id: '-1' }
      dataValues = { ...dataValues, regional: regions }
    } else if (isGR(currentUser)) {
      filterValues = { marca_id: currentUser.organizationId, regional_id: currentUser.regionId }
      dataValues = {
        ...dataValues,
        regional: regions.filter((item) => item.value === currentUser.regionId),
        region_id: currentUser.regionId,
        distrito: await fetchDistrict(currentUser.regionId)
      }
    } else {
      filterValues = {
        marca_id: currentUser.organizationId,
        regional_id: currentUser.regionId,
        distrito_id: currentUser.districtId
      }

      const district = await fetchDistrict(currentUser.regionId)

      dataValues = {
        ...dataValues,
        regional: regions.filter((item) => item.value === currentUser.regionId),
        distrito: district.filter((item) => item.value === currentUser.districtId)
      }
    }

    setInternalfilter({ ...filterValues })
    setData({ ...data, ...dataValues })
  }

  async function fetchRegions(organizationId) {
    try {
      const params = { active: true }

      if (organizationId && organizationId !== -1) {
        params.organizationId = organizationId
      }

      if (!isAdmin(currentUser)) {
        params.organizationId = currentUser.organizationId
      }

      let regions = await request(api.retrieaveRegions({ ...params }))

      regions.push({ id: '-1', name: ' TODOS' })

      return regions.map((item) => {
        return { value: item.id, description: item.name }
      })
    } catch (error) {
      console.error({ error })
    }
  }

  async function fetchDistrict(values) {
    try {
      const items = await request(api.listDistrict({ regionId: values, active: true }))

      return items.map((item) => {
        return {
          value: item.id,
          description: item.name,
          regionId: item.regionId
        }
      })
    } catch (error) {
      console.error({ error })
    }
  }

  async function fetchCategories() {
    try {
      const items = await api.listCategoriesDropDown({
        active: true
      })
      return items
    } catch (error) {
      console.error({ error })
    }
  }

  async function fetchActionTypes(value) {
    try {
      const items = await api.listEibCategoriaAcoesByCategoryDropDown({ active: true, idCategoria: value })

      return items
    } catch (error) {
      console.error({ error })
    }
  }

  async function onChangeOrganization(field, value) {
    setData({ ...data, regional: await fetchRegions(value) })

    if (filter.marca_id) {
      setInternalfilter({ ...internalFilter, marca_id: value, regional_id: '-1', distrito_id: null })
    }
  }

  async function onChangeRegion(field) {
    if (filter.regional_id) {
      setInternalfilter({ ...internalFilter, distrito_id: null, regional_id: field })
    }

    setData({ ...data, region_id: field, distrito: await fetchDistrict(field) })
  }

  async function onChangeDistrict() {
    setData({ ...data, categoria: await fetchCategories() })
  }

  async function onChangeCategories(field) {
    setData({ ...data, tipo_de_acao: await fetchActionTypes(field) })
    if (filter.categoria_de_acao_id) {
      setInternalfilter({ ...internalFilter, categoria_de_acao_id: field, tipo_de_acao_id: null })
    }
  }

  function validateFindButton(iFilter) {
    if (isAdmin(currentUser)) {
      return !(iFilter.safra_id && iFilter.marca_id && iFilter.regional_id)
    } else {
      return !(iFilter.safra_id && iFilter.regional_id)
    }
  }

  return (
    <>
      <Card className="ant-card gx-card ant-card-bordered">
        <Form layout="vertical">
          <Formik initialValues={{}} onSubmit={() => {}}>
            {({ errors, setFieldValue }) => {
              const setFieldValueWithState = (field, value) => {
                setInternalfilter({ ...internalFilter, [field]: value })
                return setFieldValue(field, value)
              }

              const rowSpan = 4

              return (
                <>
                  <Row type="flex" justify="start">
                    <CustomSelect
                      maxWidth={'12vw'}
                      showSearch
                      field="safra_id"
                      label={'Safra'}
                      errors={errors}
                      setFieldValue={setFieldValueWithState}
                      rowSpan={rowSpan}
                      value={internalFilter}
                      values={data.safra}
                      required
                    />
                    <SelectOrganization
                      maxWidth={'12vw'}
                      errors={errors}
                      field="marca_id"
                      label={getMessage('organization')}
                      setFieldValue={setFieldValueWithState}
                      formValues={internalFilter}
                      rowSpan={rowSpan}
                      onChangeWithField={onChangeOrganization}
                      required
                    />

                    <CustomSelect
                      maxWidth={'12vw'}
                      showSearch
                      field="regional_id"
                      label={'Regional'}
                      errors={errors}
                      setFieldValue={setFieldValueWithState}
                      rowSpan={rowSpan}
                      value={internalFilter}
                      values={data.regional}
                      onChange={onChangeRegion}
                      required
                    />

                    <CustomSelect
                      maxWidth={'12vw'}
                      showSearch
                      field="distrito_id"
                      label={'Distrito'}
                      errors={errors}
                      setFieldValue={setFieldValueWithState}
                      rowSpan={rowSpan}
                      value={internalFilter}
                      values={data.distrito}
                      onChange={onChangeDistrict}
                    />

                    <CustomSelect
                      maxWidth={'12vw'}
                      showSearch
                      field="categoria_de_acao_id"
                      label={'Categoria de Ação'}
                      errors={errors}
                      setFieldValue={setFieldValueWithState}
                      rowSpan={rowSpan}
                      value={internalFilter}
                      values={data.categoria}
                      onChange={onChangeCategories}
                    />
                    <CustomSelect
                      maxWidth={'12vw'}
                      showSearch
                      field="tipo_de_acao_id"
                      label={'Tipo de Ação'}
                      errors={errors}
                      setFieldValue={setFieldValueWithState}
                      rowSpan={rowSpan}
                      value={internalFilter}
                      values={data.tipo_de_acao}
                    />
                  </Row>
                  <div className="horizontal-line" style={{ margin: '20px 0px 20px' }}></div>
                  <Row type="flex" justify="start">
                    <Col span={14}></Col>
                    <Col span={5}>
                      <Button
                        icon="search"
                        className="bgPrimary"
                        style={{ width: '100%' }}
                        type="dashed"
                        onClick={handleClickFilter}
                        disabled={validateFindButton(internalFilter)}
                      >
                        {getMessage('search')}
                      </Button>
                    </Col>
                    <Col span={5}>
                      <Button
                        icon="close"
                        style={{
                          width: '100%',
                          borderColor: '#EE778F',
                          color: '#EE778F'
                        }}
                        type="ghost"
                        onClick={handleClickClearFilter}
                      >
                        {getMessage('cleanFilters')}
                      </Button>
                    </Col>
                  </Row>
                </>
              )
            }}
          </Formik>
        </Form>
      </Card>
    </>
  )
}
